import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const Expiry = () => {
  const data = [
    ['Month', 'Expiry Value (%)'],
    ['January', 1.2],
    ['February', 1.1],
    ['March', 1.3],
    ['April', 1.25],
    ['May', 1.15],
  ];

  const options = {
    title: 'Expiry Value as % of Sales',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Expiry Value (%)' },
    legend: { position: 'top' },
    curveType: 'function',
    colors: ['#F44336'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="LineChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Expiry;